module.exports = __webpack_public_path__ + "img/no-data.057747a6.svg";